export enum ReturnDraftType {
    Surplus = "Surplus",
    Express = "Express",
    Direct = "Direct",
    Rapid = "Rapid",
    Special = "Special",
}
